import { AtDividerVariants } from './at-divider.variants';

/**
 * Enum for divider orientation.
 * Use `HORIZONTAL` for standard line dividers and `VERTICAL` for stacked content separation.
 */
export enum EDividerDirectionalVariants {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

/**
 * Enum for divider thickness styles.
 * These are design-token-driven variants used for visual emphasis.
 */
export enum EDividerVariants {
  THIN = 'thin',
  THICK = 'thick',
  THICKER = 'thicker',
}

/**
 * Enum for divider color themes.
 * These values are mapped to design tokens and can vary based on background context.
 */
export enum EDividerColors {
  GREY = 'grey',
  WHITE = 'white',
  BLACK = 'black',
  GREEN = 'green',
}

/**
 * Props for the `AtDivider` component.
 * Extend from Tailwind Variants config to include direction, intent, and color-based styling.
 */
export interface IAtDividerProps extends AtDividerVariants {
  /**
   * Theme color for the divider (from `EDividerColors` enum).
   * Defaults to `'grey'`.
   */
  color?: EDividerColors;
  /**
   * Visual weight or thickness of the divider.
   * Defined via the `EDividerVariants` enum.
   */
  intent: EDividerVariants;
  /**
   * Layout orientation of the divider.
   * Horizontal dividers span across blocks; vertical dividers segment side-by-side content.
   */
  direction: EDividerDirectionalVariants;
  /**
   * Optional Tailwind class overrides for fine-grain control.
   */
  customClasses?: string;
  /**
   * If `true`, hides the divider from assistive technologies (e.g., screen readers).
   */
  decorative?: boolean;
}
